export const questionBankList = "QUESTION_BANK_LIST";
export const questionDifficultyList = "QUESTION_DIFFICULTY_LIST";